var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 44,
    viewBox: "0 0 50 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.248 15.168h21.504M20.221 22h15.531M26.195 28.832h9.557",
    stroke: "#9BAEF1",
    strokeWidth: 2.3,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "media/images/Ham-5176d221.svg";
export { SvgHam as ReactComponent };